(ns common.schema.entities.workspace.kyc.questions.ubo
  (:require
   [common.country :as country]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]
   [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]
   [common.schema.entities.workspace.kyc.templates.templates :as templates]))

(def ubo-categories-options
  [{:key :shares-over-25
    :translations {:en "Over 25% share ownership"
                   :fi "Yli 25% omistusoikeus"}}
   {:key :voting-rights-over-25
    :translations {:en "Over 25% voting rights"
                   :fi "Yli 25% äänivalta"}}
   {:key :right-to-dismiss-board
    :translations {:en "Right to nominate or dismiss the majority of the board members"
                   :fi "Oikeus nimittää tai erottaa enemmistö hallituksen jäsenistä."}}
   {:key :mob-ceo-or-similar
    :translations {:en "Board member, CEO or equivalent position."
                   :fi "Hallituksen jäsen, toimitusjohtaja tai vastaava asema"}}])

(def all-questions
  {:kyc-ubo/primary-ubo-category
   {:data/type         :data.type/keyword
    :conditional-field (fn [_answers kyc-process]
                         (not (templates/natural-person-templates-keys (:kyc-process/template
                                                                        kyc-process))))
    :options           ubo-categories-options
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en "This person is considered an UBO due to"
                        :fi
                        "Henkilöä pidetään tosiasiallisena edunsaajana seuraavalla perusteella"}}
   :kyc-ubo/ubo-category-ownership
   {:data/type         :data.type/percentage
    :conditional-field (fn [answers]
                         (= :shares-over-25 (:kyc-ubo/primary-ubo-category answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en "Ownership %"
                        :fi "Omistusoikeus %"}}
   :kyc-ubo/ubo-category-voting-rights
   {:data/type         :data.type/percentage
    :conditional-field (fn [answers]
                         (= :voting-rights-over-25 (:kyc-ubo/primary-ubo-category answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en "Voting rights %"
                        :fi "Äänioikeus %"}}
   :kyc-ubo/ubo-category-position
   {:data/type         :data.type/text
    :conditional-field (fn [answers]
                         (= :mob-ceo-or-similar (:kyc-ubo/primary-ubo-category answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en "Specify the position"
                        :fi "Kirjoita kuvaus henkilön asemasta"}}
   :kyc-ubo/last-name
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Last name"
                       :fi "Sukunimi"}}
   :kyc-ubo/first-name
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "First name"
                       :fi "Etunimi"}}
   :kyc-ubo/middle-names
   {:data/type    :data.type/text-simple
    :translations {:en "Middle names"
                   :fi "Toiset nimet"}}
   :kyc-ubo/dob
   {:data/type    :data.type/date
    :translations {:en "Date of birth"
                   :fi "Syntymäaika"}}
   :kyc-ubo/pob
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Place of birth"
                       :fi "Syntymäpaikka"}}
   :kyc-ubo/cob
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Place of birth - Country"
                       :fi "Syntymämaa"}}
   :kyc-ubo/pid
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Personal identity code"
                       :fi "Henkilötunnus"}}

   :kyc-ubo/tin
   {:data/type :data.type/text-simple
    :translations {:en "TIN"}}

   :kyc-ubo/source-of-wealth
   {:data/type    :data.type/keyword-multi
    :options      kyc-options/source-of-funds-options-person
    :translations {:en "Source of wealth"
                   :fi "Sijoitusvarojen alkuperä"}}

   :kyc-ubo/source-of-wealth-salaries-amount
   {:data/type         :data.type/currency-value
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/salaries} (:kyc-ubo/source-of-wealth answers)))
    :translations      {:en "Annual salary circa"
                        :fi "Vuosipalkka noin"}}

   :kyc-ubo/source-of-wealth-capital-income-amount
   {:data/type         :data.type/currency-value
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/capital-income}
                               (:kyc-ubo/source-of-wealth answers)))
    :translations      {:en "Annual capital income circa"
                        :fi "Vuosittainen pääomatulo noin"}}

   :kyc-ubo/source-of-wealth-inheritance-amount
   {:data/type         :data.type/currency-value
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/inheritance}
                               (:kyc-ubo/source-of-wealth answers)))
    :translations      {:en "Inheritance amount circa"
                        :fi "Perinnön määrä noin"}}

   :kyc-ubo/source-of-wealth-other-amount
   {:data/type         :data.type/currency-value
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/other} (:kyc-ubo/source-of-wealth answers)))
    :translations      {:en "Other source, amount circa"
                        :fi "Muut varat määrä"}}

   :kyc-ubo/source-of-wealth-other-specify
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/other} (:kyc-ubo/source-of-wealth answers)))
    :translations      {:en "Other source"
                        :fi "Muut varat, alkuperä"}}

   :kyc-ubo/lifeline-confirm-funds-are-not-proceeds-of-crime-or-terrorism
   {:data/type :data.type/confirm
    :translations {:en "I/We confirm that the information provided above is a full and accurate disclosure of the source of funds/wealth and that the funds have no connection whatsoever with the financing of terrorism activities and  are not the proceeds of any crime or criminal activity. The Legal Entity is acting for the ultimate economic benefit or under the control of the individual(s) indicated in this form and it is not acting in the economic benefit or interest of any other undisclosed person(s) and/or organization(s). 
                       
                       I/We and/or the Legal Entity will not contravene with the provisions of Luxembourg laws and regulations on the prevention of money laundering and terrorism financing. 
                       
                       I/We further confirm that I/we and/or the Legal Entity will provide Lifeline Ventures with any information or documents that it may require in order to satisfy itself that the money or property is not the proceeds of any crime or criminal activity"}}

   :kyc-ubo/lifeline-source-of-wealth-freeform-text
   {:data/type :data.type/text-multiline
    :translations {:en "Please provide a full description of the source of wealth of the UBO (i.e. how the overall wealth has been generated), detail the types of business activities and in which jurisdiction it was created (please respond with as much detail as possible)."}}

   :kyc-ubo/address
   {:data/type         :data.type/text-multiline
    :conditional-field (fn [answers]
                         (not= :mob-ceo-or-similar (:kyc-ubo/primary-ubo-category answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en "Street address"
                        :fi "Kotiosoite"}}
   :kyc-ubo/zip-code
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers]
                         (not= :mob-ceo-or-similar (:kyc-ubo/primary-ubo-category answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en "Zip code"
                        :fi "Postinumero"}}
   :kyc-ubo/city
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers]
                         (not= :mob-ceo-or-similar (:kyc-ubo/primary-ubo-category answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en "City"
                        :fi "Kaupunki"}}
   :kyc-ubo/country
   {:data/type         :data.type/keyword
    :options           country/options
    :conditional-field (fn [answers]
                         (not= :mob-ceo-or-similar (:kyc-ubo/primary-ubo-category answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en "Country"
                        :fi "Maa"}}
   :kyc-ubo/nationality
   {:data/type        :data.type/keyword
    :options          country/options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Nationality"
                       :fi "Kansalaisuus"}}
   :kyc-ubo/nationalities
   {:data/type        :data.type/text-edn
    :edn-data/type    :edn-data.type/nationalities
    :options          country/options
    :mandatory-field? (fn [answers kyc-process]
                        (and (not= (:kyc-process/status kyc-process)
                                   :kyc-process.status/draft)
                             (kyc-utils/nationalities-unanswered?
                              answers
                              kyc-utils/ubo-nationality-keys)))
    :translations     {:en "Nationality"
                       :fi "Kansalaisuus"}}
   :kyc-ubo/tax-countries
   {:data/type        :data.type/text-edn
    :edn-data/type    :edn-data.type/tax-recidencies
    :options          country/options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Countries of tax residence"
                       :fi "Verotusmaat"}}
   :kyc-ubo/usa-tax-residence
   {:data/type        :data.type/keyword
    :options          kyc-options/yes-no-options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "USA citizenship and tax residency"
                       :fi "Yhdysvaltain kansalaisuus ja verovelvollisuus"}}
   :kyc-ubo/non-usa-confirmation
   {:data/type         :data.type/confirm
    :conditional-field (fn [answers]
                         (= :no (:kyc-ubo/usa-tax-residence answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en
                        (str
                         "I hereby confirm that this person is not a citizen of the United States "
                         "of America or tax resident in the USA.")
                        :fi
                        (str "Vahvistan, että tämä henkilö ei ole Yhdysvaltain kansalainen tai "
                             "verovelvollinen Yhdysvalloissa.")}}
   :kyc-ubo/usa-confirmation
   {:data/type :data.type/confirm
    :conditional-field (fn [answers]
                         (= :yes (:kyc-ubo/usa-tax-residence answers)))
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations {:en
                   (str "I hereby confirm that this person is a citizen of the United States "
                        "of America and/or tax resident in the USA, and that he/she has reported "
                        "this tax residency and his/her Tax Identification Number (TIN) above.")
                   :fi
                   (str "Vahvistan, että tämä henkilö on Yhdysvaltain kansalainen ja/tai "
                        "verovelvollinen Yhdysvalloissa, ja että hän on ilmoittanut "
                        "verovelvollisuutensa sekä veronumeronsa tällä lomakkeella")}}
   :kyc-ubo/pep
   {:data/type        :data.type/keyword
    :options          [{:key :yes
                        :translations {:en "Yes"
                                       :fi "Kyllä"}}
                       {:key :no
                        :translations {:en "No"
                                       :fi "Ei"}}]
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Is the person politically exposed?"
                       :fi "Onko henkilö poliittisesti vaikutusvaltainen?"}}
   :kyc-ubo/type-of-identification-attachment
   {:data/type        :data.type/keyword
    :options          kyc-options/identification-options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Identification type"
                       :fi "Tunnistamisasiakirjan tyyppi"}}

   :kyc-ubo/national-id-card-front-side-file
   {:data/type :data.type/file
    :translations {:en "Copy of national ID card (front side)"
                   :fi "Henkilökortin kopio (etuosa)"}}

   :kyc-ubo/national-id-card-back-side-file
   {:data/type :data.type/file
    :translations {:en "Copy of national ID card (back side)"
                   :fi "Henkilökortin kopio (takaosa)"}}

   :kyc-ubo/passport-photo-page-file
   {:data/type :data.type/file
    :translations {:en "Copy of passport (photo page)"
                   :fi "Passikopio (kuvasivu)"}}


   :kyc-ubo/identification-expires
   {:data/type        :data.type/date
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Identification document expiration date"
                       :fi "Tunnistamisasiakirjan viimeinen voimassaolopäivä"}}
   :kyc-ubo/identification-attachment
   {:data/type        :data.type/file
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Upload certified copy of a valid identification"
                       :fi "Liitä oikeaksi todistettu kopio voimassaolevasta asiakirjasta"}
    :info
    {:en (str
          "<p>True copies can be certified by a third person. The certification should contain "
          "certifier’s name, occupation or education, phone number, email address and date.</p>")
     :fi (str "<p>Asiakirjat voi oikeaksi todistaa kuka tahansa kolmas henkilö. Todistuksen tulee "
              "sisältää oikeaksi todistajan nimi, ammatti tai koulutus, puhelinnumero, "
              "sähköpostiosoite ja päivämäärä.</p>")}}

   :kyc-ubo/proof-of-residency-attachment
   {:data/type :data.type/file
    :translations {:en "Proof of residency"}
    :info {:en "<p>A proof of principal residency (i.e. utility bill, bank account statement, original certificate of residence delivered by the municipality or equivalent) not older than 6 months</p>"}}})
